import BaseResource from './base-resource';
import JsonApiResource from './jsonapi-resource';
import ReferenceResolver from './reference-resolver';

export default class RoleResource extends BaseResource {
  name: string;

  constructor(init?: Partial<RoleResource>) {
    super(init, 'roles');
    this.initialize(init);
  }
}



// WEBPACK FOOTER //
// ./common/models/role-resource.ts